import { DataViews } from '../../../modules/DataViews';
import { GetMainPhoto } from '../../../modules/GetMainPhoto';
import { KatapultJob } from '../../../modules/katapult-job/KatapultJob';
import { PickAnAttribute } from '../../../modules/PickAnAttribute';

export async function setBuildingAttachment(jobId) {
  const jobRef = KatapultJob.fromId(jobId);
  const nodes = await jobRef.getNodes();
  let update = {};
  for (const nodeId in nodes) {
    const node = nodes[nodeId];
    const nodeConnections = await jobRef.getNodeConnections(nodeId);
    const traces = await jobRef.getTraces();
    let tracesToUpdate = [];
    for (const connectionId in nodeConnections) {
      const connection = nodeConnections[connectionId];
      const otherNodeId = connection.node_id_1 === nodeId ? connection.node_id_2 : connection.node_id_1;
      const otherNode = nodes[otherNodeId];
      const otherNodeType = PickAnAttribute(otherNode.attributes, 'node_type');
      if (otherNodeType != 'building attachment') continue;
      for (const sectionId in connection.sections) {
        const section = connection.sections[sectionId];
        const mainPhoto = GetMainPhoto(section.photos);
        if (!mainPhoto) continue;
        const photo = await jobRef.getPhotoById(mainPhoto);
        if (!photo) continue;
        const photoData = photo.photofirst_data || {};
        const markers = DataViews.help.getMarkers(photoData, traces?.trace_data);
        for (const marker of markers) {
          if (marker?.over) continue;
          const markerPath = marker?._marker_context?.markerPath || '';
          const markerTrace = marker._trace;
          if (!markerTrace) continue;
          update[`photos/${mainPhoto}/photofirst_data/${markerPath}/building_attachment`] = true;
          if (!tracesToUpdate.includes(markerTrace)) tracesToUpdate.push(markerTrace);
        }
      }
    }
    const nodeMainPhotoId = GetMainPhoto(node.photos);
    if (!nodeMainPhotoId) continue;
    const nodePhoto = await jobRef.getPhotoById(nodeMainPhotoId);
    if (!nodePhoto) continue;
    const nodePhotoData = nodePhoto.photofirst_data || {};
    const nodeMarkers = DataViews.help.getMarkers(nodePhotoData, traces?.trace_data);
    for (const traceId of tracesToUpdate) {
      const nodeMarker = nodeMarkers.find((m) => m?._trace === traceId);
      if (!nodeMarker) continue;
      const nodeMarkerPath = nodeMarker?._marker_context?.markerPath || '';
      update[`photos/${nodeMainPhotoId}/photofirst_data/${nodeMarkerPath}/building_attachment`] = true;
    }
  }
  await jobRef.reference.update(update);
}
